<ng-container *ngIf="score >= 0; else noLongerMatched">
	{{score}}%
</ng-container>
<ng-template #noLongerMatched>
	No longer matched
</ng-template>
